import React from 'react'
import { GpModalShell, GpButton } from '../../components/gp'

export default function AreYouSureModal(props) {
    return (
        <GpModalShell
            open={props.open}
            onClose={props.handleClose}
            title="Confirm"
            width={460}
            footer={
                <>
                    <GpButton variant="ghost" onClick={() => props.handleClose()}>
                        No
                    </GpButton>
                    <GpButton variant="danger" onClick={() => props.yesFunction()}>
                        Yes
                    </GpButton>
                </>
            }
        >
            <div style={{ font: 'var(--gp-body)', color: 'var(--gp-ink)' }}>
                {props.question}
            </div>
        </GpModalShell>
    )
}
